// extracted by mini-css-extract-plugin
export default {"page":"page__1658b0d5","body":"body__1658b0d5","title":"title__1658b0d5","description":"description__1658b0d5"};